export const Alignments = [
    "chaotisch böse",
    "chaotisch gut",
    "chaotisch neutral",
    "neutral",
    "neutral böse",
    "neutral gut",
    "rechtschaffen böse",
    "rechtschaffen gut",
    "rechtschaffen neutral",
    "gesinnungslos"
] as const;